export const LABEL_CONTACT_CREATE = 'Contact Creation';
export const LABEL_CONTACT_UPDATE = 'Contact Update';
export const LABEL_LEAD_CREATE = 'Lead Creation';
export const LABEL_LEAD_UPDATE = 'Lead Update';